import { render } from "./GlobeInfo.vue?vue&type=template&id=d405cc7a&scoped=true"
import script from "./GlobeInfo.vue?vue&type=script&lang=js"
export * from "./GlobeInfo.vue?vue&type=script&lang=js"

import "./GlobeInfo.vue?vue&type=style&index=0&id=d405cc7a&scoped=true&lang=css"

import exportComponent from "/Users/gareth/Documents/Maps/Projects/globes-that-were/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d405cc7a"]])

export default __exports__